module.exports = __webpack_public_path__ + "media/video6.6603d86e.mp4";